import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/banner-1920x450.png";

import BottomLogoImg from "../assets/Images/bottom-logo.png";
import LineImg from "../assets/Images/line.png";
import "./HearingTimetablePage.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const HearingTimetablePage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title">
          <h1 className="banner-main-title">
            {t("hearing_timetable_page_header")}
          </h1>
          <p className="banner-subtitle">
            {t("hearing_timetable_page_header2")}
          </p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_hearing_timetable_page_link1")}</Link>
        <span>{t("breadcrumbs_hearing_timetable_page_span")}</span>
        <Link>{t("breadcrumbs_hearing_timetable_page_link2")}</Link>
      </Breadcrumbs>
      <main className="hearing-timetable-main-container">
        <section className="hearing-timetable-header-section">
          <h2 className="hearing-timetable-section-title">
            {t("hearing_timetable_page_h2")}
          </h2>
        </section>
        <section className="hearing-timetable-content-section">
          <div className="hearing-timetable-img-container">
            <img src={t("hearing_timetable_img1")} alt="" />
          </div>
        </section>
        {/* <div className="line-pic">
          <img src={LineImg} alt="" />
        </div> */}
      </main>
      <div className="temporary">
        <img src={BottomLogoImg} alt="" />
      </div>

      <Footer />
    </>
  );
};

export default HearingTimetablePage;
